import React from 'react';

import { useCommon } from '../../store/CommonContext';
import Loader from '../../components/loader/Loader';
import { FONT_FAMILY, MODAL_BORDER_RADIUS } from '../../components/constants/style-constants';
import Logo from '../../components/logo/Logo';
import Content from '../../components/blocks/Content';
import Title from '../../components/text/Title';
import HorizontalLine from '../../components/decorations/lines/HorizontalLine';
import List from '../../components/list/List';
import ListItem from '../../components/list/ListItem';
import Button from '../../components/buttons/Button';
import { redirectToSuccess } from '../../helpers/parent-helper';
import Terms from '../../components/text/Terms';

import './Success.css';

interface Props {}

const Success: React.FC<Props> = props => {
  const {
    state: { configurationLoading, orderDataLoading, configuration, orderData },
  } = useCommon();
  const amount =
    orderData?.amount && !isNaN(Number((orderData?.amount / 100).toFixed(2)))
      ? Number((orderData?.amount / 100).toFixed(2))
      : '';

  const handleClick = (): void => {
    redirectToSuccess();
  };

  if (configurationLoading || orderDataLoading) {
    return <Loader />;
  }

  return (
    <div
      className="success dialog"
      style={{
        ...(typeof configuration?.fontFamily === 'string' && { fontFamily: configuration.fontFamily }),
        ...(typeof configuration?.modalCornersRadius === 'string' && {
          borderRadius: configuration.modalCornersRadius,
        }),
      }}
    >
      <Logo imageUrl="https://portal.flex-charge.com/media/flex-logo-small.png" />
      <Content>
        <>
          <Title text={'Congratulations, you have just completed your purchase!'} />
          {/*<HorizontalLine />*/}
          <List>
            <>
              <ListItem>
                <>
                  Your payment failed
                  <span className="ui-widget-item-bold"> but your purchase was completed anyway.</span>
                </>
              </ListItem>
              <ListItem>
                <>
                  <span className="ui-widget-item-bold">You will be charged {amount} </span>
                  when the issue with your payment gets resolved.
                </>
              </ListItem>
              <ListItem>
                <>
                  You will be charged just the amount due <br />
                  <span className="ui-widget-item-bold">No interest, no fees. Ever.</span>
                </>
              </ListItem>
            </>
          </List>
        </>
      </Content>
      {/*<HorizontalLine />*/}
      <Terms />
      <Button disabled={false} text="OK" onClick={handleClick} additionalClasses="" />
      {/*<Copyright />*/}
    </div>
  );
};

export default Success;
